import * as Config from "config";
import Session from "users/__session/session";
import { currentReturnRoute } from "users/auth/return-routes/login-return-route";

export const ablyAuthUrl = `${Config.apiBaseUrl}/ably/auth`;

type AblyAuthResponse = string | Record<string, unknown>;

const parseAblyAuthResponse = async (response: Response): Promise<AblyAuthResponse> => {
  const responseText = await response.text();
  if (!responseText) return "";

  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("application/json")) {
    return responseText;
  }

  return JSON.parse(responseText) as Record<string, unknown>;
};

export const requestAblyAuth = async (): Promise<AblyAuthResponse> => {
  const session = Session.loadFromStorage(() => {});
  const token = session.authToken?.value;

  if (!token) {
    throw new Error("Cannot authenticate Ably without an Attorney Hub session.");
  }

  const response = await fetch(ablyAuthUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 401) {
    void session.logout(currentReturnRoute());
  }

  if (!response.ok) {
    throw new Error(`Ably auth failed with status ${response.status}.`);
  }

  return parseAblyAuthResponse(response);
};
